// this hook is used to get a users current venue session
import useUserBasedVenueService from "@app-contexts/dashboard/features/venues/data/services/venue/useUserBasedVenueService";
import { UserBasedVenueSerializer } from "@app-contexts/dashboard/features/venues/data/types/user-venue";
import { UseQueryOptions, UseQueryResult } from "react-query";

export const useUserVenueSession = ({
  options,
}: {
  options?: UseQueryOptions<UserBasedVenueSerializer>;
} = {}): UseQueryResult<UserBasedVenueSerializer> => {
  const { useCurrentVenueSession } = useUserBasedVenueService();

  return useCurrentVenueSession({
    options: {
      // Default: cache venue session for 5 minutes - balance between performance and freshness
      staleTime: 300000, // 5 minutes
      ...options,
    },
  });
};
